import { render, staticRenderFns } from "./WorkflowTags.vue?vue&type=template&id=378f5f38&"
import script from "./WorkflowTags.vue?vue&type=script&lang=js&"
export * from "./WorkflowTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports